export const JOBS = `/v2/guest/opportunities/job`;
